import riskchartTypes from './types/riskchart'
import riskchartService from '@/api/riskchart'

const state = {}

const actions = {
  /**
   * 获取测站信息
   */
  [riskchartTypes.GET_relation_info] ({ commit }, { SID = '22', ADCD = '', STTP = '' }) {
    return new Promise((resolve, reject) => {
      riskchartService.getRelation_info({ SID, ADCD, STTP }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取雨水情信息
   */
  [riskchartTypes.getRainWaterTotal] ({ commit }, { SID = '22', STID = '', Time = '', BeginTime = '', EndTime = '' }) {
    return new Promise((resolve, reject) => {
      riskchartService.getRainWaterTotal({ SID, STID, Time, BeginTime, EndTime }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 危险区基本信息搜索
   */
  [riskchartTypes.getDangerAreaInfo] ({ commit }, { PageIndex = '1', PageSize = '1000' }) {
    return new Promise((resolve, reject) => {
      riskchartService.getDangerAreaInfo({ PageIndex, PageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 乡镇危险区表格list
   */
  [riskchartTypes.getDangerAreaInfotown] ({ commit }) {
    return new Promise((resolve, reject) => {
      riskchartService.getDangerAreaInfotown({ }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 重要村落基本信息搜索
   */
  [riskchartTypes.getPreventionDataInfo] ({ commit }) {
    return new Promise((resolve, reject) => {
      riskchartService.getPreventionDataInfo({ }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 村落表格list
   */
  [riskchartTypes.getPreventionDataInfotown] ({ commit }, { PageIndex = '1', PageSize = '1000' }) {
    return new Promise((resolve, reject) => {
      riskchartService.getPreventionDataInfotown({ PageIndex, PageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 村落预警信息
   */
  [riskchartTypes.getWarnVillageByTown] ({ commit }) {
    return new Promise((resolve, reject) => {
      riskchartService.getWarnVillageByTown({ }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 山塘信息
   */
  [riskchartTypes.getPreventionDataInfopool] ({ commit }) {
    return new Promise((resolve, reject) => {
      riskchartService.getPreventionDataInfopool({ }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
